import React, { Component } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import DataTable from 'react-data-table-component';
import moment from "moment";

import Header from '../common/layout/header';
import Footer from '../common/layout/footer';
import Showalert from '../common/Showalert';

import { BaseUrl } from '../common/config';
 
import Popup from '../common/popup';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { format } from "date-fns";
 
class Account extends Component {


    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            temporders: [],
            loading: true,
            visible: false,
            popupView: "",
            viewImg: false,
            alertPopup: false,
            offerproducts: [],
            freeProductData: [],
            cartExistPopup: false,
            reorder_info: [],
            isElementVisible: false,
            isElementVisibleMobile: false,
            dateRange: '',
            datepickershow: false,
            datefrom: '',
            dateto: '',
            dateinvalid_error: false,
        };

        if (!localStorage.getItem("isLoggedIn"))
            window.location.href = '/';


        this.setState({ loading: true });

        this.toggleModel = this.toggleModel.bind(this);
        this.handleChangeSearch = this.handleChangeSearch.bind(this);
        this.dropdownRef = React.createRef();
        this.dropdownMobileRef = React.createRef();
        this.openFilterOptionMobile = this.openFilterOptionMobile.bind(this);
        this.openFilter = this.openFilter.bind(this);
    }

    componentDidMount() {

        document.addEventListener("mousedown", this.handleClickOutside);
        document.addEventListener("mousedown", this.handleClickMobileOutside);
        
        localStorage.removeItem('payment');

        const Hour = 60 * 60 * 1000;

        var timeInterval = '2000';

        var current = this;

        var myInterval = setInterval(function() {
            current.getAllOrders();
            clearInterval(myInterval);
            timeInterval = '';
            },timeInterval); 

       var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }        

         let authData = JSON.parse(localStorage.getItem('authData'));
         let URL = BaseUrl + "updateorders/"+authData.accountCode;
                  axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then((response) => {
                  clearInterval(myInterval);
                  this.getAllOrders();
                 }).catch((err) => {
                    console.log(err);
                 });
        this.offerProduct();
    }

   componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.removeEventListener('mousedown', this.handleClickMobileOutside);
   }

   handleClickOutside = (event) => {
    if (this.dropdownRef && !this.dropdownRef.current.contains(event.target)) { 
       this.setState({isElementVisible: false });
    }
   };

   handleClickMobileOutside = (event) => {
    if (this.dropdownMobileRef && !this.dropdownMobileRef.current.contains(event.target)) { 
       this.setState({isElementVisibleMobile: false });
    }
   };

   offerProduct(){

      let productsId = { "$in": ['4', '5']};
     
      let payload = {
            offersbyids: productsId,
        }

     var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
     }

     let URL = BaseUrl + "offersbyids";
     axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
        let responseData = response.data.data[0];
        this.setState({ offerproducts: responseData }, function(){
            this.getFreeProductList(responseData);
        });
     }).catch((err) => {
        console.log(err);
     });
    }

    getFreeProductList(responseData){

        var offerproductsList = responseData;

        if(offerproductsList !=='' && offerproductsList !== null){

            var productToBeAdded = offerproductsList.productToBeAdded;
            var stringSplit = productToBeAdded.split(',');
            var returnProductNumber = '';

            var freeProductToAdd = offerproductsList.freeProductToAdd;
            var stringFreeSplit = freeProductToAdd.split(',');
            let productsId = { "$in": stringFreeSplit };
            let payload = {
                productIds: productsId,
                priceband: localStorage.getItem('priceband')
            }

            var loginDetails = {};
            if (localStorage.getItem('authData')) {
                loginDetails = JSON.parse(localStorage.getItem('authData'));
            }

            let URL = BaseUrl + "productsbyids";
            axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
             this.setState({freeProductData: response.data});
            }).catch((err) => {
            });
      }

    }


    orderStatusSync(){
        this.setState({loading:true}); 
        var numberOfAjaxCAllPending = 0;
        var timeInterval = '30000';
        var current = this;

        var element = document.getElementById("reload-btn");
        element.classList.add("loader-btn");
        let authData = JSON.parse(localStorage.getItem('authData'));
   
        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        let URL = BaseUrl + "updateorders/"+authData.accountCode;
        axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then((response) => {
         numberOfAjaxCAllPending++;
         element.classList.remove("loader-btn");
         current.getAllOrders();
         clearInterval(myInterval);
        }).catch((err) => {
           console.log(err);   
           if (err.response.status == 400){                
            clearInterval(myInterval);
            current.getAllOrders();
           }
        });

        var myInterval = setInterval(function() {
          if(numberOfAjaxCAllPending == 0){
            numberOfAjaxCAllPending++;
            timeInterval = '';
            //current.getAllOrders();
            current.setState({alertPopup: true, cartExistPopup: false});
          }},timeInterval);


    }

    getAllOrders() {
        this.setState({ loading: true, alertPopup:false, cartExistPopup: false });
        let authData = JSON.parse(localStorage.getItem('authData'));
        
        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        let payload = {
            accountCode: authData.accountCode,
            orderdays: '30',
            datefrom: '',
            dateto: '',
        }

        let URL = BaseUrl + "orders";
        axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then((response) => {
            let responseData = [];
            responseData = response.data.data;
            this.setState({ orders: responseData, temporders: responseData, loading: false });
        }).catch((err) => {
            console.log(err);
            this.setState({ loading: false });
        });


    }

    priceFormat(price) {
        return price.toLocaleString("en-US", {
            style: "currency",
            currency: "GBP",
            minimumFractionDigits: 2
        });
    }

    getOrderDetails(order){
        this.setState({alertPopup:false, cartExistPopup: false});
        var element = document.getElementById("order_detail_view_"+order.OrderNumber);
        element.classList.add("loader-btn");
        let authData = JSON.parse(localStorage.getItem('authData'));
        var numberOfAjaxCAllPending = 0;
        var timeInterval = '30000';
        var current = this;
        
        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

       //let URL = BaseUrl + "updateorderitems/"+authData.accountCode+'/'+order.OrderNumber;
       var URL = BaseUrl + "order/"+order.OrderNumber;
       if(order.OrderStatus !== "Invoiced"){
        URL = BaseUrl + "updateorderitems/"+authData.accountCode+'/'+order.OrderNumber;
       }

        axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then((response) => {
            numberOfAjaxCAllPending++;
            let responseData = [];
            responseData = response.data.data[0];
             element.classList.remove("loader-btn");
             clearInterval(myInterval);
            current.viewOrderDetails(responseData);
            current.setState({alertPopup: false});

        }).catch((err) => {
            current.orderDetailsApi(order);
            console.log(err);
            current.setState({alertPopup: false});
        });

      var myInterval = setInterval(function() {
      if(numberOfAjaxCAllPending == 0){
        numberOfAjaxCAllPending++;
        timeInterval = '';
        current.setState({alertPopup: true});
      }},timeInterval);


    }

    orderDetailsApi(order){
       var element = document.getElementById("order_detail_view_"+order.OrderNumber);
        element.classList.add("loader-btn");
        let URL = BaseUrl + "order/"+order.OrderNumber;
        
        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then((response) => {
            let responseData = [];
            responseData = response.data.data[0];
            element.classList.remove("loader-btn");
            this.viewOrderDetails(responseData);
        }).catch((err) => {
            console.log(err);
        });

    }

    str_replace(product_name){

        if(product_name !==''){

          product_name =  product_name.replaceAll('amp;', '&');
          product_name = product_name.replaceAll("apos;'", "'' ");
          product_name = product_name.replaceAll("quot;'", "'' ");
           
          return product_name;

        }else{

            return product_name;
        }
    }

    getOrderNotes(OrderNote){
        var note_test = OrderNote.replaceAll('PIXHALLCSL', '');
          note_test =  note_test.replaceAll('amp;', '&');
          note_test = note_test.replaceAll("apos;", "'' ");
          note_test = note_test.replaceAll("apos;'", "'' ");
          note_test = note_test.replaceAll("quot;'", "'' ");  
          note_test = note_test.replaceAll("quot;", "'' ");        
          return note_test;
    }

    vatAmountCalcuation(order){
        var old_order = order;
        var totalAmount = 0;
        old_order.items.map((item, value)=>{
            if(item.TaxCode !=='' && item.TaxCode === 'T1'){
               totalAmount += item.LinePrice;
            }
        });

        return totalAmount;
    }

    viewOrderDetails(order) {
        this.setState({alertPopup: false});
        var ordertotal = 0;
        var subTotal = 0;
       // var ordertotalApi = order.OrderTotal;
        var authData = JSON.parse(localStorage.getItem('authData'));
        order.items.map((item) => { ordertotal += item.LinePrice; });;
        order.items.map((item) => { subTotal += item.UnitPrice * item.QuantityOrdered; });
        moment.locale('en-GB');
        const time = moment(order.createdAt);
        var order_created_on = time.format("DD/MM/YY HH:mm A");
        var vatTotalAmount = this.vatAmountCalcuation(order);
        var vatAmount = 0;
        if(vatTotalAmount > 0){
            vatAmount = (vatTotalAmount / 100) * 20; 
            ordertotal = subTotal + vatAmount;
        }
        
        let popupResult = <Popup
            extClass="order-pop"
            headMoreTxt={
                <>

                    <div className="order-top">
                        <div className="bottom">
                            {/*<div className='order_no_details'>
                             <h3>Order No - {order.OrderNumber}</h3>
                             <p>Order Placed at: <span className="date">{order_created_on}</span> </p>
                             <p>Order Delivery at: <span className="date">{order.DateRequired}</span> </p>
                             <p>Payment Method: <span className="pay">{order.PaymentMethod==='A'?'Pay later':'Online Payment'}</span></p>
                             {/*<p>Order Paid Status: <span className="pay">{order.OrderPaid==='YES'?'Completed':'Processing'}</span></p>
                             <p>Status: <span className="pay">{order.OrderStatus}</span></p>
                            </div>
                            <div className='order_account_details'>
                             <p>Name: <span className="date">{authData.accountName}</span> </p>
                             <p>Account Code: <span className="date">{authData.accountCode}</span> </p>
                             <p>Email Address: <span className="pay">{authData.accountEmail}</span></p>
                             <p>Address: <span className="pay">{(authData.accountAddress1 !== undefined ? authData.accountAddress1 + ", ": "") + ""  + (authData.accountAddress2 !== undefined ? authData.accountAddress2 + ", " : "") + "" + (authData.accountAddress3 !== undefined ? authData.accountAddress3 + ", " : "")+ "" + (authData.accountAddress4 !== undefined ? authData.accountAddress4 + ", ": "") + "" + (authData.accountAddress5 !== undefined ? authData.accountAddress5 : "")}</span></p>
                            </div>*/}
                            {/*
                             <div className='order_no_details'>
                             <h3>Order No - {order.OrderNumber}</h3>
                             <p><span className='ord-det-txt'>Order Placed at:</span> <span className="date">{order_created_on}</span> </p>
                             <p><span className='ord-det-txt'>Order Delivery at:</span> <span className="date">{order.DateRequired}</span> </p>
                             {order.PaymentMethod ==='A' &&
                   
                             <p><span className='ord-det-txt'>Payment Method:</span> <span className="pay">{order.OrderPaid === 'YES' ? 'Payment completed (Order by Pay Later option)':'Pay Later'}</span></p>
                             }

                             {order.PaymentMethod === 'K' &&

                             <p><span className='ord-det-txt'>Payment Method:</span> <span className="pay">Online Payment</span></p>
                             }
                             {/*<p>Order Paid Status: <span className="pay">{order.OrderPaid==='YES'?'Completed':'Processing'}</span></p>*
                             <p><span className='ord-det-txt'>Status:</span> <span className="pay">{order.OrderStatus}</span></p>
                            </div>
                            */}

                            <div className='order_no_details'>
                             <h3>Order No - {order.OrderNumber}</h3>
                             <p>Order Placed at: <span className="date"> {order_created_on}</span> </p>
                             <p>Order Delivery at: <span className="date"> {order.DateRequired} </span></p>
                             
                             {order.PaymentMethod === 'A' &&
                               <p>Payment Method:<span className="pay"> {order.OrderPaid === 'YES' ? 'Paid (Pay Later Option)':'Pay Later'}</span></p>

                             }
                             {order.PaymentMethod === 'K' &&
                               <p>Payment Method:<span className="pay">Online Payment</span></p>
                             }

                             <p>Status:<span className="pay">{order.OrderStatus}</span></p>
                            </div>

                            <div className='order_account_details'>
                             <p>Name: <span className="date">{authData.accountName}</span> </p>
                             <p>Account Code: <span className="date">{authData.accountCode}</span> </p>
                             <p>Email Address: <span className="pay">{authData.accountEmail}</span></p>
                             <p>Address: <span className="pay">{(authData.accountAddress1 !== undefined ? authData.accountAddress1 + ", ": "") + ""  + (authData.accountAddress2 !== undefined ? authData.accountAddress2 + ", " : "") + "" + (authData.accountAddress3 !== undefined ? authData.accountAddress3 + ", " : "")+ "" + (authData.accountAddress4 !== undefined ? authData.accountAddress4 + ", ": "") + "" + (authData.accountAddress5 !== undefined ? authData.accountAddress5 : "")}</span></p>
                            </div>

                        </div>
                    </div>
                </>
            }

            closebtn={<><div className='pop-header-top order-top'>    
                         <div className="head">
                            <h4>Order Details</h4>
                         </div>
                        <span onClick={() => this.setState({ popupView: "" })} className='close'></span></div></>}

            bodyMoreTxt={
                <>
                    <div className="modal-table">
                        <h4 className="item-title">Ordered Items</h4>
                        <div className="checkout-table">
                            <div className="table_overflow">
                                <table>
                                    <thead>
                                        <tr>
                                            <td>Product</td>
                                            <td>Unit of Sale</td>
                                            <td>Quantity</td>
                                            <td align="center">Price</td>
                                            <td align='right'>Total</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {order.items.map((item, index) => {

                                            return (item.QuantityOrdered > 0 && <tr>
                                                <td data-title="Product" className='data-product-hide'>{this.str_replace(item.Description)} ({item.ProductNumber}){item.TaxCode !=='' && item.TaxCode === 'T1' && <span className='color-red'>*</span>}
                                                    {item.OfferFlag == "true" && <span className='offer-tag-wrap'><span className="offer-tag">Special Offer</span></span>}

                                                   </td>
                                                <td data-title="Unit of Sale">{item.PricingUnit}</td>
                                                <td data-title="Quantity">{item.QuantityOrdered}</td>
                                                <td data-title="Price" align="center">{this.priceFormat(item.UnitPrice)}</td>
                                                <td data-title="Total" align='right'>{this.priceFormat(item.LinePrice)}</td>

                                            </tr>)
                                        })}</tbody>
                                          <thead className='ord-grand-total'>

                                      {order.OrderNote !=='' && order.OrderNote !== null && 
                                        <tr>
                                            <td  align="left" width={120} colSpan="7">Order Notes: <span className='order_remarks'> {this.getOrderNotes(order.OrderNote)}</span></td>
                                        </tr>
                                        }

                                        <tr>
                                            <td  align="right" width={120} colSpan="4">Sub Total:</td>
                                            <td align="right">{this.priceFormat(subTotal)}</td>
                                        </tr>

                           
                                         {vatAmount > 0 && 
                                         <tr>
                                            <td align="right" width={120} colSpan="4" className='td-vat-fee'>
                                                <span className="strong">VAT <span className='vat-txt'>(20% of <span className='vat-amt'>{this.priceFormat(vatTotalAmount)}</span>)<span className='color-red'>*</span> :</span></span>
                                            </td>
                                            <td className='cart-prod-vat' align="right">{this.priceFormat(vatAmount)}</td>
                                          </tr>
                                          }

                                        
                                        <tr>
                                            <td  align="right" width={120} colSpan="4">Shipping:</td>
                                            <td align="right"><span className='color-red'>FREE</span></td>
                                        </tr>
                            
                                        <tr><td  align="right" width={120} colSpan="4">Grand Total:</td><td align="right">{this.priceFormat(ordertotal)}</td></tr>


                                      </thead>

                                </table>
                            </div>
                            {/* <div className="print-buttons">
                                <a className="button print-Ord-btn"><i className="fa fa-print"></i> Print Order</a>
                                    </div> */}
                        </div>

                    </div>
                </>
            }
        />;

        this.setState({ popupView: popupResult });

    }

    reOrderDetails(order){

     this.setState({alertPopup: false, cartExistPopup: false});

     var cartItems = JSON.parse(localStorage.getItem('cartItems'));

     if(cartItems !== '' && cartItems !== null && cartItems.length > 0){
        this.setState({cartExistPopup: true, reorder_info: order});
        return false;
     }

     var element = document.getElementById("reorder_btn"+order.OrderNumber);
     element.classList.add("loader-btn");

      var product_code_list = [];

      if(order !==''){
        order.items.map((item)=>{
            if(item.QuantityOrdered > 0 ){
              product_code_list.push(item.ProductNumber);
            }
        });
      }
 
      let productsId = { "$in": product_code_list };
     
      let payload = {
            productIds: productsId,
            priceband: localStorage.getItem('priceband')
        }

       var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

       let URL = BaseUrl + "productsbyids";

         axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
           
           if(response.data.data !== ''){
            this.reorder_cart(response.data, order);
           }

        }).catch((err) => {
          
        });

    }

    reorder_cart(order, previous_order){

        var element = document.getElementById("reorder_btn"+previous_order.OrderNumber);

        var newitems = [];
        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = '';

        if(offerproductsList !== ''){
         productToBeAdded = offerproductsList.productToBeAdded;
         stringSplit = productToBeAdded.split(',');
        }

        localStorage.setItem('cartItems', JSON.stringify(newitems));

        var extra_value = [];
        var returnProductNumber = 0;
        var newArray = [];

        if(stringSplit !== ''){
         order.data.map((item)=>{
         stringSplit.filter(function(value) {
            
           if(value ===  item.productNumber){
            newArray.push(item.productNumber);
             returnProductNumber++;
           }
         });
         });
        }

        var freeProductExist = 0;

        var returnProductNumberIndex = 0;
           
        previous_order.items.map((prev_item)=> {
            
        var product_price = 0;

        var cartItems = JSON.parse(localStorage.getItem("cartItems"));
            
           if(prev_item.QuantityOrdered > 0 ){

            

            order.data.map((newItem)=>{

                if(prev_item.UnitPrice === 0){
                     freeProductExist = 1;
                }

                if(prev_item.ProductNumber === newItem.productNumber && prev_item.UnitPrice > 0){

                      if(prev_item.UnitPrice === 0){
                        product_price = 0;
                      }else{
                        product_price = newItem.PDP_Price1;
                      }

                      // console.log(newItem.productNumber, 'newItem');
                      // console.log(this.checkOfferProduct(newItem.productNumber), 'newItem.productNumber');

                      newItem['qty'] = prev_item.QuantityOrdered;
                      newItem['product_type'] = 'Normal';
                      newItem['offer_applicable'] = this.checkOfferProduct(newItem.productNumber);
                      newItem.PDP_Price1 = product_price;
                      newitems.push(newItem);
                }
            
            });
           
           }
        
        });

        localStorage.setItem('reorder_free_product_exist', '0');

        if(returnProductNumber !== 0 && freeProductExist == 1){

            localStorage.setItem('reorder_free_product_exist', freeProductExist);
        }

       // console.log(returnProductNumber, 'returnProductNumber');
        element.classList.remove("loader-btn");
        //if(returnProductNumber === 1){
         localStorage.setItem('cartItems', JSON.stringify(newitems));
      //  }
         window.location.href = '/checkoutpay';
    }

    checkOfferProduct(productNumber){

        //console.log(productNumber, 'productNumber');

        var offerproductsList = this.state.offerproducts;
        var productToBeAdded = '';
        var stringSplit = '';

        if(offerproductsList !== ''){
         productToBeAdded = offerproductsList.productToBeAdded;
         stringSplit = productToBeAdded.split(',');
        }

        var offer_product_tag = 'No';

        if(stringSplit !== ''){
          stringSplit.filter(function(value) {
           if(value == productNumber){
            offer_product_tag = 'Yes';
           }
          });
         }

         return offer_product_tag;
    }

     reorderConfirm(){

     this.setState({cartExistPopup: false});
     var order = this.state.reorder_info;
     var element = document.getElementById("reorder_btn"+order.OrderNumber);
     element.classList.add("loader-btn");

      var product_code_list = [];

      if(order !==''){
        order.items.map((item)=>{
            if(item.QuantityOrdered > 0 ){
              product_code_list.push(item.ProductNumber);
            }
        });
      }
 
      let productsId = { "$in": product_code_list };
     
      let payload = {
            productIds: productsId,
            priceband: localStorage.getItem('priceband')
        }

       let URL = BaseUrl + "productsbyids";

       var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

       axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then(async (response) => {
        
           if(response !==''){
            this.reorder_cart(response.data, order);
           }

        }).catch((err) => {
          
        });


    }

    orderRefresh(order){
        var element = document.getElementById("refresh_order_id"+order.OrderNumber);
        element.classList.add("fa-spin");
        if(order.OrderStatus !== "Invoiced"){
            this.setState({alertPopup:false, loading: true, cartExistPopup: false});
            let authData = JSON.parse(localStorage.getItem('authData'));
            var numberOfAjaxCAllPending = 0;
            var timeInterval = '30000';
            var current = this;
            let URL = BaseUrl + "updateorderitems/"+authData.accountCode+'/'+order.OrderNumber;
         
            var loginDetails = {};
            if (localStorage.getItem('authData')) {
                loginDetails = JSON.parse(localStorage.getItem('authData'));
            }

           axios.get(URL, {headers: {"Auth-Token": loginDetails.token}}).then((response) => {
                numberOfAjaxCAllPending++;
                let responseData = [];
                responseData = response.data.data[0];
                current.setState({alertPopup: false, loading:false, cartExistPopup: false});
                current.getAllOrders();
                 clearInterval(myInterval);
                
            }).catch((err) => {
                console.log(err);
                current.setState({alertPopup: false, cartExistPopup: false});
            });

          var myInterval = setInterval(function() {
          if(numberOfAjaxCAllPending == 0){
            numberOfAjaxCAllPending++;
            timeInterval = '';
            current.setState({alertPopup: false, cartExistPopup: false});
          }},timeInterval);

         }else{
            
            this.getAllOrders();
            this.setState({alertPopup: false, cartExistPopup: false});
        }
    }

    toggleModel() {
        this.setState({
            visible: !this.state.visible
        });
    }


    handleChangeSearch(value){
  
        this.setState({searchText: value});
        this.searchProduct(value); 
         
    }

    clearSearch() {
        this.setState({ searchText: "" });
        this.setState({ orders: this.state.temporders });
    }
   
    searchProduct(value) {
        const lowercasedValue = value.toLowerCase().trim();
        const filteredData = this.state.temporders.filter((item) => {         
           
            return item.OrderNumber.toLowerCase().includes(lowercasedValue) || item.OrderStatus.toLowerCase().includes(lowercasedValue) || item.DateOrdered.toLowerCase().includes(lowercasedValue) 
        });
        this.setState({ orders : filteredData });
    }

    orderTotal(items, orderTotalAmount){

        var ordertotal = 0;
        
        if(items !== undefined && items !==''){

         if(orderTotalAmount != null || orderTotalAmount != undefined || orderTotalAmount > 0){

           return '£'+ orderTotalAmount;

         }else{

           items.map((item) => { ordertotal += item.LinePrice; });
           return this.priceFormat(ordertotal);
         }

        //if(items !=='' && items !== undefined){
        // items.map((item) => { ordertotal += item.LinePrice; });
        // return this.priceFormat(ordertotal);
        // }else{
        // return this.priceFormat(ordertotal);
        //}

       }else{

         if(orderTotalAmount !== null || orderTotalAmount !== undefined || orderTotalAmount > 0){

            return this.priceFormat(orderTotalAmount);

         }else{

            return this.priceFormat(ordertotal);
         }
        
       }

    }

   popupClose(){

    this.setState({ alertPopup: false, cartExistPopup: false});

   }

   openFilter = () => {

    this.setState(prevState => ({
      isElementVisible: !prevState.isElementVisible
    }));

   }


    openFilterOptionMobile = () => {
        this.setState(prevState => ({
          isElementVisibleMobile: !prevState.isElementVisibleMobile
        }));
    }


   applyOrderFilters(){

    let authData = JSON.parse(localStorage.getItem('authData'));

     if(this.state.dateRange !== ''){

       this.setState({isElementVisible: false, loading: true, alertPopup:false, cartExistPopup: false, isElementVisibleMobile: false, dateinvalid_error:false });

        var payload = {
            accountCode: authData.accountCode,
            orderdays: this.state.dateRange,
            datefrom: '',
            dateto: '',
        }

        if(this.state.dateRange == 'custom'){

          var dateval = new Date(this.state.datefrom);
          dateval = format(dateval, "yyyy-MM-dd");

          var dateval2 = new Date(this.state.dateto);
          dateval2 = format(dateval2, "yyyy-MM-dd");

          payload = {
            accountCode: authData.accountCode,
            orderdays: '',
            datefrom: dateval,
            dateto: dateval2,
           }

        }else{

          payload = {
            accountCode: authData.accountCode,
            orderdays: this.state.dateRange,
            datefrom: '',
            dateto: '',
          }
        }

        let URL = BaseUrl + "orders";

        var loginDetails = {};
        if (localStorage.getItem('authData')) {
            loginDetails = JSON.parse(localStorage.getItem('authData'));
        }

        axios.post(URL, payload, {headers: {"Auth-Token": loginDetails.token}}).then((response) => {
            let responseData = [];
            responseData = response.data.data;
            this.setState({ orders: responseData, temporders: responseData, loading: false });
             
         }).catch((err) => {
            console.log(err);
            this.setState({ loading: false });
         });

    }

   }

   clearFilterOrderSearch(){

     this.setState({isElementVisible: false, isElementVisibleMobile: false, dateRange: 3, datefrom: '', dateto: ''}, function(){

        this.getAllOrders();
     });

   }

   handleFilterChange = (e) => {

    if(e.value !== ''){

        var valueDates = '';

        if(e.value == '3'){

            valueDates = 30 * 3;

            this.setState({ datepickershow: false });

        }else if(e.value == '6'){

            valueDates = 30 * 6;

            this.setState({ datepickershow: false });

        }else if(e.value == '1Year'){

            valueDates = 365;

            this.setState({ datepickershow: false });

        }else if (e.value == 'custom'){

            valueDates = 'custom';

            this.setState({ datepickershow: true });
        }

        this.setState({dateRange: valueDates, dateinvalid_error: false });
    }

   }


   DateChange(value, type){
    if(type == 'from'){
      this.setState({ datefrom: value, dateinvalid_error:false})
    }else if(type == 'to'){

         var dateval = new Date(this.state.datefrom);
          dateval = format(dateval, "yyyy-MM-dd");

          var dateval2 = new Date(value);
          dateval2 = format(dateval2, "yyyy-MM-dd");

          if(dateval > dateval2){

            //alert('Invalid start & end date!');

            this.setState({ dateto: '', dateinvalid_error: true});

          }else{

            this.setState({ dateto: value, dateinvalid_error: false})
          }
        
    }
   }

    render() {


        const columns = [
            {
                name: "Order #",
                selector: row => row.OrderNumber,
                sortable: true,
            },
            {
                name: "Payment Method",
                selector: row => row.PaymentMethod ==='A'? (row.OrderPaid === 'YES' ? 'Paid (Pay Later)' : 'Pay Later' ) :'Online Payment',
                sortable: false,
            },
            {
                name: "Order Total (Excl. of VAT)",
                selector: row => this.orderTotal(row.items, row.OrderTotal),
                sortable: false,
            },
            {
                name: "Ordered Date",
                selector: row => row.DateOrdered,
                sortable: false,
            },
            {
                name: "Delivery Date",
                selector: row => row.DateRequired,
                sortable: false,
            },
            {
                name: "Status",
                selector: row => row.OrderStatus,
                sortable: true,
            },
            {
                name: " ",
                selector: row => <a className='view-btn' id={"order_detail_view_"+row.OrderNumber} onClick={this.getOrderDetails.bind(this, row)}>View Order</a>,
                sortable: false,
            },
            {
                name: " ",
                selector: row => <a className='re-Ord-btn'  id={"reorder_btn"+row.OrderNumber} onClick={this.reOrderDetails.bind(this, row)} >Reorder </a>,
                sortable: false,
            },
            {
                name: " ",
                selector: row => <a className='refresh-btn title-tooltip title-up' data-title='Click to view the updated status and details of this order'><i className="fa fa-refresh" id={"refresh_order_id"+row.OrderNumber} aria-hidden="true" onClick={this.orderRefresh.bind(this, row)}></i> </a>,
                sortable: false,
            }
        ];

        const customStyles = {
            rows: {
                style: {
                    minHeight: '25px',
                },
            },
            headCells: {
                style: {
                    padding: '8px', // override the cell padding for head cells

                },
            },
            cells: {
                style: {
                    padding: '8px', // override the cell padding for data cells

                },
            },
        };
 
        const paginationComponentOptions = {
            rowsPerPageText: '',
            rangeSeparatorText: '',
            selectAllRowsItem: true,
            selectAllRowsItemText: '',
            noRowsPerPage: '',
        };

        const rangeOptions = [
            { value: "3", label: "Past 3 Months" },
            { value: "6", label: "Past 6 Months" },
            { value: "1Year", label: "Past 1 Year" },
          /*{ value: "Viewall", label: "View All" }*/
            { value: "custom", label: "Custom" }
        ];

        var datelabel = "";
        var dateValue = "";
       if (this.state.dateRange == "3") {
            datelabel = "Past 3 Months";
            dateValue = "3";
        }else if (this.state.dateRange == "6") {
            datelabel = "Past 6 Months";
            dateValue = "6";
        } else if (this.state.dateRange == "365") {
            datelabel = "Past 1 Year";
            dateValue = "1Year";
        }else if (this.state.dateRange == "custom") {
             datelabel = "Custom";
             dateValue = "custom";
        }else if (this.state.dateRange == "") {
             datelabel = "Past 3 Months";
             dateValue = "3";
        }

        return (
            <>
                <Header />
               
                    <section className="acc-block">
                        <div className="sm-container">

                          <div className="acc-ttflx">
                                <h1 className="checkout-title"></h1>
                                <div className='header-tab-menu'>
                                    <a className='active' href='/account'>My Orders</a>
                                    <a href='/myaccount'>My Account</a>
                                </div>

                                <div className='filter-option-mob order-filter-option'>

                                   <div className="select-drop mobile-drop" ref={this.dropdownMobileRef}>
                                    <a className={this.state.isElementVisibleMobile == true ? 'filter-btn button active': 'filter-btn button'} onClick={this.openFilterOptionMobile}>More Filter <span className='filter-icon'><i className="fa fa-sliders" aria-hidden="true"></i></span></a>
                                    <div className={this.state.isElementVisibleMobile == true ? 'filter-bx show': 'filter-bx'}>
                                        <div className='filter-date-range'>
                                            <div className='fltr-dt-wrap'>
                                                <label>Date Range (Ordered Date):</label>
                                                <Select  
                                                   defaultValue={{value: dateValue,
                                                               label: datelabel,
                                                             }}
                                                    options={rangeOptions}

                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 6,
                                                        height: 40,
                                                        colors: {
                                                        ...theme.colors,
                                                        primary25: '#e0dedb',
                                                        primary: '#ec2f45',
                                                        },
                                                    })}

                                                    onChange={this.handleFilterChange}
                                                
                                                />
                                            </div>
                                            <div className= {this.state.datepickershow == true ? 'fltr-dt-range show' : 'fltr-dt-range'}>
                                                <div className='fltr--date'>
                                                    <span>From</span>
                                                    <DatePicker
                                                        selected={this.state.datefrom}
                                                        placeholderText="From date"
                                                        showDisabledMonthNavigation
                                                        dateFormat="dd/MM/yyyy"
                                                        disablePast={true}
                                                        onChange={(date) => this.DateChange(date, 'from')}
                                                    />
                                                    <span className='date-icon'><i className="fa fa-calendar" aria-hidden="true"></i></span>
                                                </div>
                                                <div className='fltr--date'>
                                                    <span>To</span>
                                                    <DatePicker
                                                        selected={this.state.dateto}
                                                        placeholderText="To date"
                                                        showDisabledMonthNavigation
                                                        dateFormat="dd/MM/yyyy"
                                                        disablePast={true}
                                                        onChange={(date) => this.DateChange(date, 'to')}
                                                    />
                                                    <span className='date-icon'><i className="fa fa-calendar" aria-hidden="true"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                       
                                        <div className='filter-btns'>
                                            <button type="button" className="button clear-btn" value="Clear Filters" onClick={this.clearFilterOrderSearch.bind(this)}>Clear</button>
                                            <button type="button" className="button apply-btn" value="Apply Filters" onClick={this.applyOrderFilters.bind(this)}>Apply </button>
                                        </div>
                                    </div>
                                   </div>

                                </div>

                                <a href='/home' className="acc-back"><i className="fa fa-arrow-left"></i> Back To Main</a>
                            </div>
                            
                           <div className="field-group search-orders">
                               <div className="search-order-left">
                                <input type="text" className="search-ord" name="Search" placeholder="Search for Orders" value={this.state.searchText} onChange={e => this.handleChangeSearch(e.target.value)}  />
                                    <button type="button" className="button search-ord-btn" onClick={e => this.searchProduct(this.state.searchText)} ><i className="fa fa-search"></i></button>
                                    <input type="button" className="button reset-btn ord-reset" value="Reset" onClick={e => this.clearSearch()} />
                                    {/*<a className="button reload-btn " value="Reload" onClick={e => this.orderStatusSync()} id="reload-btn">Reload </a>*/}
                                </div>

                                   <div className="select-drop" ref={this.dropdownRef}>
                                    <a className={this.state.isElementVisible == true ? 'filter-btn button active' : 'filter-btn button'} onClick={this.openFilter}>More Filter <span className='filter-icon'><i className="fa fa-sliders" aria-hidden="true"></i></span></a>
                                    <div className={this.state.isElementVisible  == true ? 'filter-bx show': 'filter-bx'} >
                                        <div className='filter-date-range'>
                                            <div className='fltr-dt-wrap'>
                                                <label>Date Range (Ordered Date):</label>
                                                <Select  
                                                    defaultValue={{value: dateValue,
                                                                   label: datelabel,
                                                                 }}
                                                    options={rangeOptions}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        borderRadius: 6,
                                                        height: 40,
                                                        colors: {
                                                        ...theme.colors,
                                                        primary25: '#e0dedb',
                                                        primary: '#ec2f45',
                                                        },
                                                    })}
                                                  onChange={this.handleFilterChange}
                                                />
                                            </div>
                                            <div className={this.state.datepickershow == true ? 'fltr-dt-range show' : 'fltr-dt-range'}>
                                                <div className='fltr--date'>
                                                    <span>From</span>
                                                    <DatePicker
                                                        selected={this.state.datefrom}
                                                        placeholderText="From date"
                                                        showDisabledMonthNavigation
                                                        dateFormat="dd/MM/yyyy"
                                                        disablePast={true}
                                                        onChange={(date) => this.DateChange(date, 'from')}
                                                    />
                                                    <span className='date-icon'><i className="fa fa-calendar" aria-hidden="true"></i></span>
                                                </div>
                                                <div className='fltr--date'>
                                                    <span>To</span>
                                                    <DatePicker
                                                        selected={this.state.dateto}
                                                        placeholderText="To date"
                                                        showDisabledMonthNavigation
                                                        dateFormat="dd/MM/yyyy"
                                                        disablePast={true}
                                                        onChange={(date) => this.DateChange(date, 'to')}
                                                    />
                                                    <span className='date-icon'><i className="fa fa-calendar" aria-hidden="true"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                       
                                       {this.state.dateinvalid_error === true && <span className="color-red">Invalid Start & End date!</span>}
                                        <div className='filter-btns'>

                                            <button type="button" className="button clear-btn" onClick={this.clearFilterOrderSearch.bind(this)}>Clear</button>
                                            <button type="button" className="button apply-btn" onClick={this.applyOrderFilters.bind(this)}>Apply </button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                           
                           {this.state.orders.length > 0 && this.state.loading == false && 
                           <p className="account-total-records">Total Records: {this.state.orders.length > 0 ? this.state.orders.length : ''}</p>
                           }
                           
                            <div className="acc-table">
                                <div className="table_overflow">
                                    {this.state.popupView}

                                    <DataTable
                                        columns={columns}
                                        data={this.state.orders}
                                        customStyles={customStyles}
                                        pagination
                                        noDataComponent = 'Sorry, there are no order records to display.'
                                        // noDataComponent={this.state.searchText === '' || this.state.searchText === undefined ? 'There are no records to display' : (this.state.searchText !=='' && this.state.orders.length === 0 ?'Sorry, no orders were matching your keyword, try a new search.' : '')}
                                        paginationPerPage={25}
                                        progressPending={this.state.loading}
                                        paginationRowsPerPageOptions={[25, 50, 75, 100]}
                                        paginationComponentOptions={paginationComponentOptions}
                                    />


                                </div>
                            </div>
                        </div>
                    </section>

                     {this.state.alertPopup === true && <Showalert title='oops!' message="The Server is busy, please try after sometime" />
                     }

                    {this.state.cartExistPopup === true && 
                      <div className='custom-alert-pop common_alert_popup'>
                        <div className='custom-alert-container'>
                            <div className='custom-alert-wrap'>
                                <div className='custom-alert-header'>
                                    <h4>Alert</h4>
                                </div>
                                <div className='custom-alert-body'>
                                    <p>Your cart contains items, Do you want to discard it and reorder these items.</p>

                                    <div className='alert-buttons'>
                                        <a className="popup-alert-btn button" onClick={this.reorderConfirm.bind(this)}>Ok</a>
                                        <a onClick={this.popupClose.bind(this)} className="popup-alert-btn button">Cancel</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }

                <Footer />
            </>
        );
    }
}

export default Account;